<div class="map-preview-wrapper">
  <div class="content">
    <div id="map"></div>

    <div class="opacity-control-wrapper">
      <div class="min_max-values">
        <span class="text-small">0%</span>
        <span class="text-small">100%</span>
      </div>
      <mat-slider
        [min]="opacityControlConfig.min"
        [max]="opacityControlConfig.max"
        [color]="'primary'"
        [step]="opacityControlConfig.step"
        [formControl]="opacityControl"
      ></mat-slider>

    </div>

    <div class="extent" *ngIf="selectedLayer">
      <div class="top">
        <h5 class="title">{{ "components.CustomMaps.NorthEast" | translate }}</h5>
        <div class="coordinates">
          <p class="coordinate-label">
            {{'coordinates.abbreviated.latitude' | translate}}
            <span class="coordinate-value">{{ selectedLayer.Extent.NorthEast.Latitude | limit: 5 }}</span>
          </p>
          <p class="coordinate-label">
            {{'coordinates.abbreviated.longitude' | translate}}
            <span class="coordinate-value">{{ selectedLayer.Extent.NorthEast.Longitude | limit: 5 }}</span>
          </p>
        </div>
      </div>
      <div class="bottom">
        <h5 class="title">{{ "components.CustomMaps.SouthWest" | translate }}</h5>
        <div class="coordinates">
          <p class="coordinate-label">
            {{'coordinates.abbreviated.latitude' | translate}}
            <span class="coordinate-value">{{ selectedLayer.Extent.SouthWest.Latitude | limit: 5 }}</span>
          </p>
          <p class="coordinate-label">
            {{'coordinates.abbreviated.longitude' | translate}}
            <span class="coordinate-value">{{ selectedLayer.Extent.SouthWest.Longitude | limit: 5 }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
